import React from 'react'

const EventAlcoIcon = (props) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={25}
      height={23}
      fill="none"
      {...props}
    >
      <path
        fill="#FA0707"
        d="M20.992 15.325c.398.275.892.176 1.182-.243 1.377-1.943 2.183-4.614 2.183-7.34 0-2.727-.796-5.42-2.183-7.341-.29-.43-.784-.519-1.182-.243-.398.276-.462.795-.15 1.247 1.182 1.7 1.849 3.985 1.849 6.336 0 2.351-.688 4.614-1.85 6.336-.3.453-.247.972.15 1.248ZM17.02 12.445c.355.254.86.177 1.15-.254.828-1.114 1.322-2.76 1.322-4.448 0-1.689-.494-3.322-1.322-4.46-.29-.419-.796-.507-1.15-.242-.441.309-.505.86-.172 1.313.623.883.978 2.109.978 3.39 0 1.28-.366 2.494-.978 3.388-.323.463-.269.993.172 1.313ZM2.3 22.999h13.503c1.688 0 2.29-.497 2.29-1.468 0-2.848-3.472-6.777-9.04-6.777-5.58 0-9.053 3.93-9.053 6.777 0 .971.602 1.468 2.3 1.468Zm6.752-10.221c2.311 0 4.3-2.12 4.3-4.88 0-2.726-2-4.746-4.3-4.746s-4.3 2.064-4.3 4.769c0 2.737 2 4.857 4.3 4.857Z"
      />
    </svg>
  )
}

export default EventAlcoIcon
